// ─── BARRE de navigation entre les mois : « ‹ [Mois 🎯] › » ───────
// Extraite le 16/08 pour pouvoir la FIGER hors du défilement (Suivi) : la
// barre vivait dans VueMois et partait avec la liste. Quatre écrans en
// portent une copie — ils migreront au fil de l'eau.
// `avant`/`apres` : mois voisins qui portent quelque chose (« » saute) ;
// absents, les doubles chevrons se grisent.
import React, { useMemo } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { useUI, useT } from '@mop/core';
import { decalerMois, moisCourant } from './services/occurrences';

const HIT = { top: 8, bottom: 8, left: 8, right: 8 };

const libelleMois = (mk, t) => {
  const [y, m] = String(mk || '').split('-').map(Number);
  const noms = t('commun.moisLongs');
  return `${(Array.isArray(noms) ? noms[m - 1] : '') || mk || ''} ${y || ''}`.trim();
};

export default function BarreMois({ mois, onMois, avant = null, apres = null }) {
  const UI = useUI();
  const t = useT();
  const s = useMemo(() => makeStyles(UI), [UI]);
  const surCourant = mois === moisCourant();

  return (
    <View style={s.barre}>
      <TouchableOpacity onPress={() => avant && onMois?.(avant)} hitSlop={HIT} disabled={!avant}>
        <Text style={[s.nav, !avant && s.off]}>«</Text>
      </TouchableOpacity>
      <TouchableOpacity onPress={() => onMois?.(decalerMois(mois, -1))} hitSlop={HIT}>
        <Text style={s.nav}>‹</Text>
      </TouchableOpacity>
      <View style={s.titreZone}>
        <Text style={s.mois}>{libelleMois(mois, t)}</Text>
        {/* 🎯 collé au titre, grisé quand on y est : l'alignement ne bouge
            jamais — même règle que My Calendar. */}
        <TouchableOpacity onPress={() => onMois?.(moisCourant())} hitSlop={HIT}
          disabled={surCourant} accessibilityLabel={t('finances.moisCourant')}>
          <Text style={[s.cible, surCourant && s.off]}>🎯</Text>
        </TouchableOpacity>
      </View>
      <TouchableOpacity onPress={() => onMois?.(decalerMois(mois, 1))} hitSlop={HIT}>
        <Text style={s.nav}>›</Text>
      </TouchableOpacity>
      <TouchableOpacity onPress={() => apres && onMois?.(apres)} hitSlop={HIT} disabled={!apres}>
        <Text style={[s.nav, !apres && s.off]}>»</Text>
      </TouchableOpacity>
    </View>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  barre: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', paddingVertical: 6 },
  titreZone: { flexDirection: 'row', alignItems: 'center', gap: 8 },
  mois: { fontSize: 16, fontWeight: '800', color: UI.ink },
  cible: { fontSize: 15 },
  nav: { fontSize: 24, color: UI.accent, fontWeight: '300', width: 40, textAlign: 'center' },
  off: { opacity: 0.28 },
});
